module.exports = __webpack_public_path__ + "img/count-budget.90e4fc86.svg";